import styled, { css } from 'styled-components'
import Icon from '@mdi/react'
//import CommonButton from 'components/Button/CommonButton'
import theme from 'theme_'

export const APListLineItemOuterFrame = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px 4px 0px 6px;
  gap: ${theme.spacing.tiny};
  width: 100%;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.05);

  @media ${theme.devices.mobile} {
    padding: 0px 4px 0px 6px;
    gap: 6px;
  }
`

export const APListLineItemStatusFrame = styled.div`
  order: 0;
`

export const APListLineItemIconFrame = styled.div`
  order: 1;
  margin-top: -2px;
`

export const APListLineItemNameInner = styled.div`
  display: flex;
  flex-direction: row;
  overflow-y: hidden; /* Hide horizontal scrollbar */
  overflow-x: hidden; /* Add vertical scrollbar */
  :hover {
    overflow-x: scroll;
  }
  order: 5;
`

export const APListLineItemText = styled.span`
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  color: ${theme.colors.otterWarmBlack};
`

export const APLineItemBase = css`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    white-space: nowrap;
    align-items: left;
    gap: ${theme.spacing.tiny};
    height: 45px;
    width: 100%
    color: ${theme.colors.otterWarmBlack};
    padding-top:5px;
`

export const APListLineItemName = styled.div`
  ${APLineItemBase};
  font-size: 16px;
  min-width: 350px;

  display: flex;
  flex-direction: row;

  @media ${theme.devices.tablet} {
    min-width: 185px;
  }

  @media ${theme.devices.mobile} {
    min-width: 150px;
  }

  @media ${theme.devices.mediumDesktop} {
    min-width: 350px;
  }
`
export const APListLineItemMac = styled.div`
  ${APLineItemBase};
`
export const APListLineItemVersion = styled.div`
  ${APLineItemBase};
  @media ${theme.devices.tablet} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`
export const APListLineItemIP = styled.div`
  ${APLineItemBase};
  @media ${theme.devices.tablet} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListLineItemUptime = styled.div`
  ${APLineItemBase};
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListLineItemClients = styled.div`
  ${APLineItemBase};
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`
export const APListLineItemBytes = styled.div`
  ${APLineItemBase};
  @media ${theme.devices.tablet} {
    display: none;
  }

  @media ${theme.devices.tabletLandscape} {
    display: flex;
  }

  @media ${theme.devices.mobile} {
    display: none;
  }

  @media ${theme.devices.mediumDesktop} {
    display: flex;
  }
`

export const APListLineItemTrash = styled.div`
  ${APLineItemBase};
  min-width: 35px;
`

export const APListIndicator = styled(Icon)``

export const APListLineItemUptimeFont = styled.span`
    width: 74px;
    height: 22px;
    font-style: normal;
    font-weight: 325;
    font-size: 14px;
    line-height: 22px;
    color: ${theme.colors.otterWarmBlack}
    flex: none;
    order: 1;
    flex-grow: 0;
`

export const APListLineItemClientsFont = styled.span`
  width: 19px;
  height: 22px;
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 22px;
  color: ${theme.colors.otterWarmBlack};
  flex: none;
  order: 1;
  flex-grow: 0;
`

export const APListLineItemBytesFont = styled.span`
  width: 46px;
  height: 22px;
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 22px;
  color: ${theme.colors.otterWarmBlack};
  flex: none;
  order: 1;
  flex-grow: 0;
  white-space: nowrap;
`

export const APListLineItemLLDPName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 12px;
  width: 143.67px;
  height: 22px;
  flex: none;
  order: 6;
  flex-grow: 1;
`

export const APListLineItemLLDPNameFont = styled.span`
  width: 115px;
  height: 22px;
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 22px;
  color: ${theme.colors.otterWarmBlack};
  flex: none;
  order: 1;
  flex-grow: 0;
`

export const APListLineItemLLDPPort = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 12px;
  width: 143.67px;
  height: 22px;
  flex: none;
  order: 7;
  flex-grow: 1;
`

export const APListLineItemLLDPPortFont = styled.span`
  width: 74px;
  height: 22px;
  font-style: normal;
  font-weight: 325;
  font-size: 14px;
  line-height: 22px;
  /* identical to box height, or 157% */

  color: ${theme.colors.otterWarmBlack};
  flex: none;
  order: 1;
  flex-grow: 0;
`

export const APListLineItemHightlighted = styled.span`
  font-weight: 750;
`

export const APListLineItemDeleteIcon = styled(Icon)``

export const APNetworkDeviceIcon = styled.img``
